import { useContext, useEffect, useState } from "react";
import { Card, Input, Tooltip, Typography, message } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { AuthContext } from "../../context/AuthProvider";
import { authService } from "../../services/authService";
import styles from "./settings.module.scss";

const { Title, Text } = Typography;

const ApiCredentialsTab: React.FC = () => {
  const { user } = useContext(AuthContext);
  const [credentials, setCredentials] = useState<{ clientId?: string; clientSecret?: string }>({});

  useEffect(() => {
    if (!user?.id) return;
    authService
      .getClientCredentials(user.id)
      .then(setCredentials)
      .catch((e: any) => {
        if (e?.response?.status === 404) {
          message.error(e?.message || 'Failed to load API credentials');
        }
      });
  }, [user?.id]);

  const copyToClipboard = (value: string, label: string) => {
    navigator.clipboard.writeText(value);
    message.success(`${label} copied to clipboard`);
  };

  return (
    <Card
      className={`${styles.card} ${styles.apiCard}`}
      title={
        <div className={styles.cardTitleWrapper}>
          <Title level={5} className={styles.cardTitleText}>API Credentials</Title>
          <Text type="secondary" className={`${styles.cardSubtitle} ${styles.apiCardSubtitle}`}>
            Authenticate your API requests. Refer to the XD API Documentation for integration guidelines.
          </Text>
        </div>
      }
    >
      <div className={styles.credentialsList}>
        <div className={styles.credentialField}>
          <Text type="secondary" className={styles.fieldLabel}>Client ID</Text>
          <Input
            readOnly
            value={credentials.clientId || ""}
            className={styles.credentialInput}
            suffix={
              <Tooltip title="Copy">
                <FontAwesomeIcon
                  icon={faCopy}
                  className={styles.copyIcon}
                  onClick={() => copyToClipboard(credentials.clientId || "", "Client ID")}
                />
              </Tooltip>
            }
          />
        </div>
        <div className={styles.credentialField}>
          <Text type="secondary" className={styles.fieldLabel}>Client Secret</Text>
          <Input
            readOnly
            value={credentials.clientSecret ? "••••••••••••••••••••••••" : ""}
            className={styles.credentialInput}
            suffix={
              <Tooltip title="Copy">
                <FontAwesomeIcon
                  icon={faCopy}
                  className={styles.copyIcon}
                  onClick={() => copyToClipboard(credentials.clientSecret || "", "Client Secret")}
                />
              </Tooltip>
            }
          />
        </div>
      </div>
    </Card>
  );
};

export default ApiCredentialsTab;
